

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { Rule, RuleAction, ActionTypeLabel, actionTypeLabels, actionSettingsForActionType, Field, dataTypeByFieldType, ActionType } from "@/types"
import { DataType, Operator, operatorLabels, operatorsByFieldType } from "@/types/insights"
import { CaseColumn, caseColumns } from "@/types/caseColumns"

import RuleActionsSettings from "@/components/Config/Rules/RuleActionsSettings.vue"
import { IntegrationOutOption } from "@/types/integration"
import Guid from "@/scripts/guid"
import { TenantFeatures } from "@/types/tenantFeatures"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"rule-actions-settings": RuleActionsSettings,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class RuleActions extends Vue {
	@Prop({ default: null })
	public rule!: Rule

	@Prop({ type: Boolean, default: true })
	public canEdit!: boolean;

	@Prop({ default: () => [] })
	private integrationOuts!: IntegrationOutOption[]

    @setup.State fields!: Field[];
	public setValueFields: CaseColumn[] = [];

	@Getter isFeatureEnabled!: (featureKey: TenantFeatures) => boolean;

	private actionTypes: ActionTypeLabel[] = actionTypeLabels;

	public get columns () {
		return [
			{
				key: "label",
				label: "Title"
			},
			{
				key: "actionType",
				label: "Action Type"
			},
			{
				key: "settings",
				label: "Settings"
			},
			{
				key: "",
				label: ""
			}
		]
	}

	public created () {
		const allowedGlobal = ["statusId", "severityId"]

		this.setValueFields = [
			...caseColumns.filter(f => allowedGlobal.includes(f.key)),
			...this.fields.filter(f => f.dataType && ((operatorsByFieldType[f.dataType!] || f.dataType === "file-only")))
				.map(f => {
					return {
						label: f.title,
						key: "fields." + f.id,
						fieldId: f.id,
						dataType: f.dataType,
						dataSourceId: f.dataSourceId,
						description: f.description,
						dynamicField: true,
						fieldExtensions: f.extensions,
						fieldDataType: dataTypeByFieldType[f.dataType!] !== undefined
							? dataTypeByFieldType[f.dataType!]
							: null
					} as CaseColumn
				})
		]
	}

	public addAction () {
		// Create new dummy action and add it to the list of actions
		let newAction: RuleAction

		const settings: {[key: string]: string} = {}
		settings["field"] = ""
		settings["newValue"] = ""
		settings["newValueLabel"] = ""
		settings["fieldDataType"] = ""

		newAction = {
			id: null,
			key: Guid.newGuid(),
			label: "",
			actionType: 0,
			settings: settings
		}

		this.rule.actions.push(newAction)
	}

	public removeAction (action: RuleAction) {
		if (!this.rule) {
			return
		}

		this.rule.actions.removeWhere(a => a === action)
	}

	public actionTypeSelected (actionType: ActionType, action: RuleAction) {
		if (action) {
			Vue.set(action, "actionType", actionType)
		}
	}

	public addActionButtonDisabled () : boolean {
		let actionsNotValid: boolean = false

		if (this.rule.actions.length > 0) {
			actionsNotValid = this.rule.actions.some(t => t.label.length === 0)
			if (actionsNotValid) {
				this.$emit("invalid")
			} else {
				this.$emit("valid")
			}
		} else {
			actionsNotValid = false
			this.$emit("valid")
		}

		return actionsNotValid
	}

	public get enabledActionTypes (): ActionTypeLabel[] {
		return this.actionTypes.filter(t => !t.requireFeature || this.isFeatureEnabled(t.requireFeature))
	}
}

